import React from 'react';
import {Image, Title, Slideshow} from './../../Basics';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars

const Particle15 = () => (<div>

  <Title>Hindernisse im Exoskelett-Parcours</Title>
  <Slideshow>

    <section>
      <Image
        source={require('./15_Bild_1_Schiefe_Ebene_EXO_Team_VariLeg_AlessandroDellaBella_065.jpg')}
        title='---'
        caption='Beim Parcours mit Exoskeletten sollten die Teilnehmer unter anderem über eine schiefe Ebene laufen...'
      />
    </section>

    <section>
      <Image
        source={require('./15_Bild_2_Inseln_EXO_Team_SG-Mechatronics_AlessandroDellaBella_060.jpg')}
        title='---'
        caption='... oder durften ihre Füsse beim Laufen nur auf die grauen Platten setzen. Die Aufgaben sollten Bedingungen simulieren, wie sie beispielsweise auf unbefestigten Waldwegen herrschen.'
      />
    </section>

    <section>
      <Image
        source={require('./15_Bild_3_Sofa_EXO_Team_PolyWalk-EPFL_NicolaPitaro_6941.jpg')}
        title='---'
        caption='Nur schon von einem Sessel aufzustehen ist für jemanden mit gelähmten Beinen trotz Exoskelett eine grosse Herausforderung.'
      />
    </section>

    <section>
      <Image
        source={require('./15_Bild_4_EXO_Team.jpg')}
        title='---'
        caption='Auch eine Treppe hatten die Teilnehmer zu überwinden. Fotos: ETHZ'
      />
    </section>


</Slideshow>

  <Particle
  number={14}
  />

  <Particle
  number={17}
  />

</div>);

export default Particle15;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle15/Particle15.js
 **/